const enigmes = {
    enigme1: {
        title: " Rumeur",
coords:"256,315,301,419",
       shape: "rect",
        text: " Vous avez entendu les dernières rumeurs ? <br>L’un des seigneurs d’une famille noble d’Est-Rive se serait rapproché du Seigneur Solon.<br> Dame Sonja tenterait par tous les moyens de connaître son identité.", 
    },
    Enigme2: {
        title: "Rumeur",
coords:"306,434,333,342",
       shape: "rect",
        text: " Tu ne devais pas parler aussi fort.<br> Si on t’entend, les Sans-Visage pourraient être tentés de t’interroger.<br> Il ne faudrait pas qu’ils apprennent que tu en sais autant.", 
    },
    Enigme3: {
        title: " Rumeur",
coords:"378,327,452,417",
       shape: "rect",
        text: " Je ne sais pas si je devrais en parler,<br> mais l’autre jour en rentrant dans la salle du trône, <br>j’ai vu la reine qui caressait la tête de dragon. <br>Ce n’est pas la première fois que je la vois faire ça et à chaque fois elle me regarde d’un air mauvais.<br> Qui sait à quoi elle joue ?", 
    },
    Enigme4: {
        title: " Rumeur",
coords:"530,323,594,418",
       shape: "rect",
        text: " Pardonnez-moi, auriez-vous aperçu la reine ? <br>Je cherche à m’entretenir avec elle au sujet d’une affaire importante.<br> Je suis très las et mes jambes me font souffrir et je souhaiterais<br> régler cette affaire de façon urgente.<br> Je reviens du marché des rives et la journée a été harassante.", 
    },
    Enigme5: {
        title: " Rumeur",
coords:"804,325,880,441",
       shape: "rect",
        text: " L’autre jour, en allant au marché des rives, <br>j’ai aperçu un noble vêtu de bleu s’adresser à un vieillard avec une canne dans une petite ruelle.<br> Ça ne m’aurait pas marqué plus que ça si je ne l’avais pas vu lui donner une imposante bourse en or. <br>Je me demande bien ce qu’il faut faire pour se faire payer aussi grassement. <br>Sans doute que c’est dangereux mais je ne cracherais pas dessus.", 
    },

};
export default enigmes;